export default __webpack_public_path__ + "static/media/ConveyorSplitter.256.a02bca42.png";